import React, {useEffect, Fragment, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {useSelector, useDispatch} from "react-redux";
import {
  getAllCourseRunDemands, getAllMyCourseRunDemands,
  setCourseRunDemandsStatus,
} from "../store/action/CourseAction";
import Head from "../../components/Head";
import Toast from "../../components/Toast";
import Loader from "../../components/Loader";
import {txtRT, txtTable, txtPage} from "../../utils/texts";
import {paramCase} from "change-case";
import DarsUpTable from "../../components/table/DarsUpTable";
import {SelectColumnFilter} from "../../components/table/Filters";
import {Button} from "react-bootstrap";
import {PAGE_SIZE} from "../../utils/constants";


const MyCourseRunDemands = ({history}) => {

  const [roleName, setRoleName] = useState("");

  const {myCourseRunDemands, isLoading, error} = useSelector(
    (state) => state.myCourseRunDemands
  );

  console.log(myCourseRunDemands);
  console.log(isLoading);

  const permission = useSelector((state) => state.permissionSelected.data);

  const params = new URLSearchParams(useLocation().search);

  const pageNumberQuery = Number(params.get("page"));

  const dispatch = useDispatch();

  const columns = React.useMemo(() => [
    {
      Header: txtTable.caption,
      accessor: 'title',
      hasSort: true,
    },
    {
      Header: txtTable.status,
      accessor: 'translated_status',
      Filter: SelectColumnFilter,
      filter: 'includes',
    },
    {
      Header: () => null,
      accessor: 'id',
    },
    {
      Header: 'توضیحات کوتاه',
      accessor: 'short_description',
      disableFilters: true,
    },
  ], [])

  const fetchData = (params) => {
    let newParams;
    if (!params)
      newParams = {
        page: pageNumberQuery || 1,
        search: '',
        ordering: ''
      }
    else newParams = {...params}
    console.log(newParams)
    dispatch(getAllMyCourseRunDemands(paramCase(permission.role.name), PAGE_SIZE, newParams));
  }

  useEffect(() => {
    if (permission?.role) {
      setRoleName(paramCase(permission.role.name))
      if (paramCase(permission.role.name) !== "owner" && paramCase(permission.role.name) !== "course-creator" && paramCase(permission.role.name) !== "instructor")
        history.push("/");
      if (paramCase(permission.role.name)) fetchData();
    }
  }, [permission]);

  return (
    <Fragment>
      <Head title="لیست درخواست های دوره من"/>
      {myCourseRunDemands?.results ? (
        <>
          <div className="kt-portlet p-3">
            <div className="kt-portlet__body">
              <DarsUpTable
                data={myCourseRunDemands.results}
                columns={columns}
                hasPagination={true}
                fetchData={fetchData}
                loading={isLoading}
                hasCounterColumn={true}
                count={myCourseRunDemands.count}
              />
            </div>
          </div>
        </>
      ) : (
        <div className="kt-portlet p-3">
          <div className="kt-portlet__body">
            <div className="rounded bg-light my-3" style={{minWidth: "60%"}}>
              <p className="h4 text-center px-2 py-5 mb-0">
                {txtPage.CourseRunDemands.notCourses.description}
              </p>
              <Link to="/courses/new">
                <Button>ایجاد دوره</Button>
              </Link>
            </div>
          </div>
        </div>
      )}
      <Loader visible={isLoading}/>
    </Fragment>
  );
};


export default MyCourseRunDemands